"use client";

import Image from "next/image";
import React from "react";

import { useTranslation } from "@/app/i18n/client";
import { useAuthenticationStore } from "@/libs/store/accountStore/useAuthenticationStore";

interface RegisterCardComponentProps {
  accountId: string;
}

const RegisterCardComponent: React.FC<RegisterCardComponentProps> = ({
  accountId,
}) => {
  const { setOpenLoginPopup, setTitle } = useAuthenticationStore();
  const { t } = useTranslation("home");

  if (accountId) {
    return null;
  }

  // if (status === "loading" && !accountId) {
  //   return (
  //     <>
  //       <div className="hidden h-20 w-full border shadow-[0px_4px_24px_0px_rgba(0,0,0,0.08)] md:block">
  //         <div className="mx-auto flex h-full max-w-7xl items-center justify-between">
  //           <Skeleton className="h-6 w-2/5 rounded-lg" />
  //           <Skeleton className="h-12 w-[12.0938rem] rounded-lg" />
  //         </div>
  //       </div>
  //       <div className="p-4 md:hidden">
  //         <div className="h-[4.75rem] w-full">
  //           <Skeleton className="size-full rounded-lg rounded-tr-[3rem]" />
  //         </div>
  //       </div>
  //     </>
  //   );
  // }

  return (
    <div>
      {/* desktop */}
      <div className="relative hidden w-full shrink-0 items-center overflow-hidden rounded-[8px_48px_8px_8px] bg-white shadow-[0px_4px_24px_0px_rgba(0,0,0,0.08)] md:flex md:rounded-none md:bg-gradient-to-r md:from-[#FFFAFA] md:to-[#FFF5F5] md:shadow-[0px_4px_8px_0px_rgba(0,0,0,0.04),0px_1px_1px_0px_rgba(0,0,0,0.04)]">
        <span className="z-1 absolute left-0 top-0 h-full w-[80px] bg-[url('https://d31jk6ljx7wihh.cloudfront.net/images/register-card/bg-striped-desktop@2x.webp')] md:bg-[length:104px_80px]" />
        <div className="relative mx-auto hidden w-full justify-between p-4 md:flex xl:max-w-7xl xl:px-0">
          <div className="flex items-center gap-2">
            <Image
              src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/luggage.svg"
              alt="Illustrate - Register"
              className="h-auto object-contain"
              width={48}
              height={48}
            />
            <div className="ml-13 flex items-center gap-[2px]">
              <p className="bg-black bg-clip-text text-[14px] font-bold text-transparent xl:text-[16px]">
                {t("registerCard.loginRegister")}&nbsp;
              </p>
              <p className="bg-gradient-to-r from-[#DD3422] to-[#FC3B26] bg-clip-text text-[14px] font-bold text-transparent xl:text-[16px]">
                Gother
              </p>
            </div>
            <div className="flex items-center gap-[2px]">
              <Image
                src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/icon-privileges.svg"
                alt="Illustrate - Green Bag"
                width={24}
                height={18}
                className="h-auto object-contain"
              />
              <p className="text-[14px] font-normal text-black xl:text-[16px]">
                {t("registerCard.privileges")}
              </p>
            </div>
            <div className="flex items-center gap-[2px]">
              <Image
                src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/icon-discount.svg"
                alt="Coupon Illustration"
                width={24}
                height={18}
                className="h-auto object-contain"
              />
              <p className="text-[14px] font-normal text-black xl:text-[16px]">
                {t("registerCard.discount")}
              </p>
            </div>
          </div>
          <div
            className="relative z-[2] inline-flex h-[48px] cursor-pointer items-center justify-center gap-2 rounded-[12px] px-[16px] py-[12px] text-white"
            style={{
              backgroundImage:
                "linear-gradient(87deg, #2B292E 2.1%, #5A575C 97.9%)",
            }}
            onClick={() => {
              setOpenLoginPopup(true, true);
              setTitle(t("registerCard.button"));
            }}
            onKeyDown={() => {}}
          >
            <p className="text-center text-[14px] font-bold text-white xl:text-[16px]">
              {t("registerCard.button")}
            </p>
          </div>
          <span className="z-1  absolute right-0 top-0 h-full w-[400px] bg-[url('https://d31jk6ljx7wihh.cloudfront.net/images/register-card/pattern-gother-desktop@2x.svg')] md:bg-[length:400px_80px] xl:right-[-62px]" />
        </div>
      </div>

      {/* mobile */}
      <div
        className="block cursor-pointer overflow-hidden p-4 md:hidden"
        onClick={() => {
          setOpenLoginPopup(true, true);
          setTitle(t("registerCard.button"));
        }}
        onKeyDown={() => {}}
      >
        <div className="relative w-full shrink-0 overflow-hidden rounded-[8px_48px_8px_8px] bg-white py-4 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.08)] md:hidden">
          {/* Background pattern image */}
          <Image
            src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/bg-striped-mobile@2x.webp"
            alt="Pattern"
            width={104}
            height={80}
            className="pointer-events-none absolute left-0 top-0 z-0"
          />

          {/* Text content */}
          <div className="relative z-10 inline-flex flex-col items-start justify-center gap-[2px] pl-4">
            <div className="flex items-center">
              <p className="bg-black bg-clip-text text-[16px] font-bold text-transparent">
                {t("registerCard.loginRegister")} &nbsp;
              </p>
              <p className="bg-gradient-to-r from-[#DD3422] to-[#FC3B26] bg-clip-text text-[16px] font-bold text-transparent">
                Gother
              </p>
            </div>
            <div className="flex items-start gap-2">
              <div className="flex items-center gap-[2px]">
                <Image
                  src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/icon-privileges.svg"
                  alt="Illustrate - Green Bag"
                  width={16}
                  height={16}
                  className="h-auto object-contain"
                />
                <p className="text-[12px] font-normal text-black">
                  {t("registerCard.privileges")}
                </p>
              </div>
              <div className="flex items-center gap-[2px]">
                <Image
                  src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/icon-discount.svg"
                  alt="Coupon Illustration"
                  width={16}
                  height={16}
                  className="h-auto object-contain"
                />
                <p className="text-[12px] font-normal text-black">
                  {t("registerCard.discount")}
                </p>
              </div>
            </div>
          </div>

          {/* Background pattern image */}
          <div className="absolute bottom-0 right-0 z-0">
            <Image
              src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/pattern-gother-mobile@2x.svg"
              alt="Pattern Gother"
              width={193}
              height={80}
              className="h-[80px] w-[193px] object-cover"
            />
            <Image
              src="https://d31jk6ljx7wihh.cloudfront.net/images/register-card/luggage-half.svg"
              alt="Illustration"
              width={104}
              height={72}
              className="absolute bottom-0 right-0 h-[72px] w-[104px] object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterCardComponent;
